import { useLang } from '@/i18n';
import gtm from 'eco-design-reliance/gtm';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { url, theme } from '../../config';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('stream.overview');
    const thePageUrl = `/${locale}/${url}`;

    const dataA: EcoNavProductProps = {
        theme,
        productItems: [
            {
                value: 'Name',
                label: t('nav_name'),
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: t('nav_overview'),
                href: thePageUrl,
            },
            {
                value: 'Specs',
                label: t('nav_specs'),
                href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: t('nav_support'),
                href: `${thePageUrl}/support`,
            },
        ],
        buyItems: [
            {
                value: 'Buy',
                label: t('nav_buy'),
                href: 'https://nl.ecoflow.com/products/stream-thuisbatterij',
            },
        ],
    };
    const tabChange = (item: any) => {
        if (tabCallback) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: item.value,
                product_name: t('nav_name'),
            });
            tabCallback(item.value);
        }
    };

    return <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} />;
}
